/*!
 * seededRandom.js — the same random numbers in every window that has the seed
 * © 2026 Rob Canning — GPLv3
 *
 * The live console gives each run a seed and sends it with the line, so the
 * projector window draws what the laptop draws: a line on a signal rolled
 * afresh at each hit, a cluster's members, a poly synth's voices.
 *
 *     const random = seededRandom(seed, line, hit)   // a Math.random stand-in
 *
 * The same seed and keys give the same numbers, here and anywhere else.
 */

/** A new seed: 32 bits. */
export const newSeed = () => (Math.random() * 4294967296) >>> 0;

/** 32-bit FNV-1a of a string, folded into h. */
function mix(h, s) {
  for (let i = 0; i < s.length; i++) h = Math.imul(h ^ s.charCodeAt(i), 16777619);
  return Math.imul(h ^ 0xff, 16777619) >>> 0;
}

/** A random() for the seed and keys: numbers in [0, 1), the same for the same arguments. */
export function seededRandom(seed, ...keys) {
  let a = mix(2166136261, String(seed >>> 0));
  for (const k of keys) a = mix(a, String(k));
  return () => {                         // mulberry32
    a = (a + 0x6D2B79F5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}
